(function () {
  'use strict';
  var LS = window.LS;
  var configNode = document.getElementById('CartUpsellConfig');
  if (!LS || !configNode) return;
  var strings = JSON.parse(configNode.textContent);
  var busy = false;
  var memory = {};

  function state() {
    var node = document.querySelector('[data-cart-upsell-state]');
    return node ? JSON.parse(node.textContent) : null;
  }
  function storageKey(productId) { return 'ls:cart-upsell:hidden:' + productId; }
  function dismissed(productId) {
    var key = storageKey(productId);
    try { return sessionStorage.getItem(key) === 'true'; } catch (e) { return !!memory[key]; }
  }
  function saveDismissal(productId, value) {
    var key = storageKey(productId);
    memory[key] = value;
    try { if (value) sessionStorage.setItem(key, 'true'); else sessionStorage.removeItem(key); } catch (e) { /* Storage can be disabled. */ }
  }
  function applyDismissal() {
    var data = state();
    if (!data) return;
    if (!data.hasKit) saveDismissal(data.productId, false);
    var offer = document.querySelector('[data-cart-upsell]');
    if (!offer) return;
    var hidden = dismissed(data.productId);
    offer.querySelector('#CartUpsellContent').hidden = hidden;
    offer.querySelector('[data-upsell-hide]').hidden = hidden;
    offer.querySelector('[data-upsell-hide]').setAttribute('aria-expanded', String(!hidden));
    offer.querySelector('[data-upsell-show]').hidden = !hidden;
  }
  function announce(text) {
    var node = document.querySelector('[data-upsell-status]');
    if (node) { node.textContent = text; node.hidden = false; }
  }
  function jsonOk(response) {
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }
  function getCart() {
    return fetch(LS.routes.cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(jsonOk);
  }

  document.addEventListener('ls:cart-refreshed', applyDismissal);
  document.addEventListener('shopify:section:load', applyDismissal);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-upsell-hide], [data-upsell-show]');
    if (!button) return;
    var offer = button.closest('[data-cart-upsell]');
    var hide = button.hasAttribute('data-upsell-hide');
    saveDismissal(offer.getAttribute('data-product-id'), hide);
    applyDismissal();
    offer.querySelector(hide ? '[data-upsell-show]' : '[data-upsell-hide]').focus();
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-upsell-variant]') || !event.target.checked) return;
    var option = event.target;
    var offer = event.target.closest('[data-cart-upsell]');
    offer.querySelector('[data-upsell-price]').textContent = option.dataset.price;
    offer.querySelector('[data-upsell-button-price]').textContent = option.dataset.price;
    var compare = offer.querySelector('[data-upsell-compare]');
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    var image = offer.querySelector('.cart-upsell__image');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    offer.querySelector('[data-upsell-error]').hidden = true;
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-cart-upsell-form]')) return;
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    var data = state();
    if (!data || !data.productId) return;
    var variantId = Number(new FormData(form).get('id'));
    if (!variantId) return;
    busy = true;
    var button = form.querySelector('[type="submit"]');
    var error = form.querySelector('[data-upsell-error]');
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    error.hidden = true;
    var added = false;
    var noKit = false;
    getCart()
      .then(function (cart) {
        var parent = cart.items.find(function (item) {
          return data.triggerIds.indexOf(item.product_id) !== -1 && item.product_id !== data.productId && !item.parent_relationship;
        });
        if (!parent) { noKit = true; return; }
        // Recheck the server cart: prevents a second add after a refresh failure or stale drawer.
        if (cart.items.some(function (item) { return item.product_id === data.productId; })) return;
        return fetch(LS.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, parent_line_key: parent.key }] })
        }).then(jsonOk).then(function () { added = true; });
      })
      .then(function () { return LS.refreshCart(); })
      .then(function () {
        announce(noKit ? strings.kitRequired : strings.added);
        var close = document.querySelector('#CartDrawer [data-cart-close].cart-drawer__close');
        if (close) close.focus();
      })
      .catch(function () {
        if (added) {
          // The mutation succeeded. Never encourage another add against a stale drawer.
          form.closest('[data-cart-upsell]').hidden = true;
          announce(strings.refreshError);
        } else {
          error.textContent = strings.error;
          error.hidden = false;
        }
      })
      .finally(function () {
        busy = false;
        form.removeAttribute('aria-busy');
        button.disabled = false;
      });
  });
  applyDismissal();
})();
